import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import HeaderBox from "../../reuseableComponents/headerBox";
import IpsGroupDeficienciesAdminTable from "./ipsDeficiencyGroupAdminTable";
import IpsDeficiencyGroupForm from "./IpsDeficiencyGroupForm";
import ModalWindow from "../../reuseableComponents/ModalWindow";
import ButtonCreate from "../../reuseableComponents/buttons/ButtonCreate";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import { GET_IPS_GROUP_DEF_DATA } from "../../../queries/archiveQrys/secureQrys/ipsDeficiencyGroupAdminQrys";
import ErrorMessage from "../../reuseableComponents/ErrorHandler";

const IpsGroupDeficienciesAdmin = (props) => {
  const [modalId, setModalId] = useState("");
  const [error, setError] = useState(null);
  const [item, setItem] = useState(null);
  const [show, setShow] = useState(false);
  const [defaultDefValues, setDefaultDefValues] = useState([]);
  const [groupNextVal, setGroupNextVal] = useState("");
  const [deficiencyGroupMenu, setDeficiencyGroupMenu] = useState([]);
  const [deficiencyGroups, setDeficiencyGroups] = useState([]);
  const [deficiencyGroupsMenuLoaded, setDeficiencyGroupsMenuLoaded] = useState(false);

  useQuery(GET_IPS_GROUP_DEF_DATA, {
    onCompleted: (d) => {
      setDeficiencyGroups(d.getIpsDeficiencyGroups);
      createDeficiencyGroupDropdownValues(d.getPublicIpsDeficiencyPoints);
      setGroupNextVal(d.getIpsDeficiencyGroupNextVal);
    },
    onError: (err) => {
      setError(err);
    }
  });

  function resetState() {
    setError(null);
    setModalId("");
    setItem(null);
    setShow(false);
    setDefaultDefValues([]);
    setGroupNextVal("");
    //setDeficiencyGroups([]);
  }

  function createDeficiencyGroupDropdownValues(deficiencyArray) {
    let menu = [];
    deficiencyArray.forEach((item) => {
      let menuItem = {};
      menuItem.value = item.typeCode;
      menuItem.label = `${item.typeCode} ${item.typeDesc}`;
      menu = [...menu, menuItem];
    });
    setDeficiencyGroupMenu(menu);
    setDeficiencyGroupsMenuLoaded(true);
  }

  const handleClose = () => {
    setShow(false);
    resetState();
  };

  const handleShow = (id) => {
    setShow(id);
    setModalId(id);
  };

  const setItemObj = (value) => {
    setItem(value);
  };

  const handleNewGroup = () => {
    setItem(null);
    setShow("add");
    handleShow("new");
    setDefaultDefValues([]);
  };

  const checkNew = (item) => {
    if (item) {
      return item;
    } else {
      let newItem = {
        groupCreatedBy: "",
        groupCreatedOn: "",
        groupDescription: "",
        groupId: parseInt(groupNextVal),
        groupModifiedBy: "",
        groupModifiedOn: "",
        groupName: "",
        groupPoints: "",
        __typename: "IpsDeficiencyGroup"
      };
      return newItem;
    }
  };

  return (
    <div className='page-container ips-deficiency-group-admin-container'>
      <Row>
        <Col>
          <Link className='m-2 hyperlink' to='/' cypressid='home'>
            Home
          </Link>
          <span className='m-2'> | </span>
          <Link className='m-2 hyperlink' to='/secure/module-index' cyressid='module-index'>
            Modules
          </Link>
          <span className='m-2'> | </span>
          <Link className='m-2 hyperlink' to='/secure/ips/ips-index' cyressid='ips-index'>
            IPS Menu
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='ipsDeficiencyGroup'>
            <h3 style={{ color: "#fff" }}>IPS Deficiencies Group Admin</h3>
          </HeaderBox>
        </Col>
      </Row>
      {deficiencyGroupsMenuLoaded ? (
        <>
          <Row>
            <Col>
              <ButtonCreate label='Add New' id='ddw-primary' onClick={() => handleNewGroup()} />
              <ModalWindow
                show={show}
                item={checkNew(item)}
                onHide={handleClose}
                setItemObj={setItemObj}
                handleClose={handleClose}
                id={modalId}
                modalTitle={modalId.charAt(0).toUpperCase() + modalId.slice(1) + " IPS Deficiencies Group"}
                component={IpsDeficiencyGroupForm}
                allDeficiencies={deficiencyGroupMenu}
                nextVal={groupNextVal}
                defaultDefValues={defaultDefValues}
                setDefaultDefValues={setDefaultDefValues}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <IpsGroupDeficienciesAdminTable
                onHide={handleClose}
                setItemObj={setItemObj}
                handleShow={handleShow}
                handleClose={handleClose}
                data={deficiencyGroups}
              />
            </Col>
          </Row>
        </>
      ) : error ? (
        <ErrorMessage error={error} />
      ) : (
        <SkeletonLoader width='100%' />
      )}
    </div>
  );
};
export default IpsGroupDeficienciesAdmin;
